import { Schema, Array as A, Record, pipe } from "effect";
import { Resource } from "@brytdesigns/shopify-utils/effect";

export const CartLineIdBase = Resource.GID.pipe(
  Schema.includes("CartLine"),
  Schema.asSchema,
);

export const VariantIdBase = Resource.GID.pipe(
  Schema.includes("ProductVariant"),
  Schema.asSchema,
);

export const SellingPlanIdBase = Resource.GID.pipe(
  Schema.includes("SellingPlan"),
  Schema.asSchema,
);

export const PropertiesBase = Schema.Record({
  key: Schema.String,
  value: Schema.String,
});

export const QuantityBase = Schema.Union(
  Schema.Number,
  Schema.NumberFromString,
).pipe(Schema.asSchema);
